import React, { Component } from 'react';
import { Handle, Position, NodeResizer, useReactFlow } from '@xyflow/react';

class ResizerNodeInner extends Component {
  handleDoubleClick = (event) => {
    console.log('ResizerNode double clicked:', this.props);
    if (this.props.data?.onDoubleClick) {
      this.props.data.onDoubleClick(event, this.props);
    }
  };

  render() {
    const { data } = this.props;
    return (
      <div 
        onDoubleClick={this.handleDoubleClick}
        style={{ cursor: 'pointer' }}
      >
        <NodeResizer minWidth={100} minHeight={30} />
        <Handle
          type="target"
          position={Position.Left}
          className="custom-handle"
        />
        <div style={{ padding: 10 }}>{data.label}</div>
        <div className="resizer-node__handles">
          <Handle
            className="resizer-node__handle custom-handle"
            id="a"
            type="source"
            position={Position.Bottom}
          />
          <Handle
            className="resizer-node__handle custom-handle"
            id="b"
            type="source"
            position={Position.Bottom}
          />
        </div>
        <Handle type="source" position={Position.Right} />
      </div>
    );
  }
}

const ResizerNode = (props) => {
  const reactFlowInstance = useReactFlow();
  return <ResizerNodeInner {...props} updateNode={reactFlowInstance.updateNode} />;
};

export default ResizerNode; 